export const bankAccountStatuses = [
  { value: 1, text: 'na', theme: 'neutral', icon: 'Close' },
  { value: 2, text: 'api', theme: 'warning', icon: 'Clock' },
  { value: 3, text: 'notUsed', theme: 'neutral', icon: 'not_interested' },
  { value: 4, text: 'toBeVerified', theme: 'warning', icon: 'Clock' },
  {
    value: 5,
    text: 'enabled',
    theme: 'success',
    icon: 'Check'
  },
  { value: 6, text: 'rejectedBank', theme: 'danger', icon: 'Close' },
  { value: 7, text: 'noHolder', theme: 'neutral', icon: 'Close' },
  { value: 8, text: 'disabled', theme: 'danger', icon: 'Close' },
  { value: 9, text: 'rejectedLw', theme: 'danger', icon: 'Close' }
];

export const bankAccountTypes = [
  { value: 0, text: 'other' },
  { value: 1, text: 'iban' }
];
